<template>
  <!-- mediasoup 云屋 实时视频 组件 -->
  <div ref="box" @mouseover="showTool = true" @mouseout="showTool = false" class="video-box">
    <div id="videoloading" v-if="isCloudRoom === 'cloudRoom'">
      <img class="vedioLoad" v-if="loadingGif" src="@/icon/real-video/video-loding.gif" />
      <img class="vedioLoad" v-if="!loadingGif" src="@/icon/video-loding.gif" />
      <img id="destroyVideo" src="@/icon/real-video/close.png" />
    </div>
    <div class="monitor-wrapper" v-if="isCloudRoom === 'cloudRoom'"></div>
    <!-- 视频播放源 -->
    <img
      class="vedioLoad"
      id="falseLoad"
      :src="require('@/icon/real-video/video-loding.gif')"
    />
    <video
      id="mvcpVideo"
      ref="video"
      @timeupdate="timeupdate"
      :poster="require('@/icon/real-video/video-loding.gif')"
      autoplay
      preload="auto"
      :muted="muted"
    ></video>
    <!-- <video id="rtc_media_player" autoplay mute='true' controls ></video> -->
    <audio ref="audio" id="mvcpAudio"></audio>
    <div id="mvcpAudio1"></div>
    <!-- 顶部控制栏 -->
    <div v-show="showTool" class="monitor_topbar">
      <div class="topbar_left">
        <span v-if="device" class="left userName" :title="device.username">{{ device.username }}</span>
        <img class="net_type" :title="getSignTitle" v-if="helmetStatus" :src="getSign" />
      </div>
      <div class="topbar_mid" v-show="!toolClose">
        <!-- 拍照 -->
        <img v-if="helmetStatus && helmetStatus.photo === '1'" src="@/icon/real-video/photo-on.png" />
        <img
          v-else
          :title="$t('photograph')"
          src="@/icon/real-video/photo.png"
          @click="switchAction(ACTION.PHOTO_OPEN)"
        />
        <!-- GPS -->
        <img
          v-if="helmetStatus === null || (helmetStatus && helmetStatus.GPS && helmetStatus.GPS === '0')"
          :title="$t('GPS_BD')"
          src="@/icon/real-video/gps.png"
          @click="switchAction(ACTION.GPS_OPEN)"
        />
        <img v-else :title="$t('GPS_BD')" src="@/icon/real-video/gps-on.png" @click="switchAction(ACTION.GPS_CLOSE)" />
        <!-- LED 照明 -->
        <img
          v-if="helmetStatus === null || (helmetStatus && helmetStatus.LED && helmetStatus.LED === '0')"
          title="LED"
          src="@/icon/real-video/led.png"
          @click="switchAction(ACTION.LED_OPEN)"
        />
        <img v-else title="LED" src="@/icon/real-video/led-on.png" @click="switchAction(ACTION.LED_CLOSE)" />
        <!-- 激光 -->
        <img
          v-if="helmetStatus === null || (helmetStatus && helmetStatus.laser && helmetStatus.laser === '0')"
          :title="$t('laser')"
          src="@/icon/real-video/laser.png"
          @click="switchAction(ACTION.LASER_OPEN)"
        />
        <img
          v-else
          :title="$t('laser')"
          src="@/icon/real-video/laser-on.png"
          @click="switchAction(ACTION.LASER_CLOSE)"
        />
        <!-- 警示灯 -->
        <img
          v-if="helmetStatus === null || (helmetStatus && helmetStatus.warnlight && helmetStatus.warnlight === '0')"
          :title="$t('WarningLight')"
          src="@/icon/real-video/warningLed.png"
          @click="switchAction(ACTION.WARNLIGHT_OPEN)"
        />
        <img
          v-else
          :title="$t('WarningLight')"
          src="@/icon/real-video/warningLed-on.png"
          @click="switchAction(ACTION.WARNLIGHT_CLOSE)"
        />
        <img
          :title="$t('refresh')"
          :src="reflash"
          @click="reflashHelmet()"
          :class="[reflashClass ? 'reflashClass' : 'forbind_reflash']"
        />
      </div>
      <div class="topbar_right" :class="!liveBroadcast ? '' : 'topbar-padding'">
        <div class="left definit">
          <div class="resolution-video" @click="showList">
            {{ currentDefinit }}
          </div>
          <div class="resolut-list" v-if="definitShow">
            <ul>
              <li v-for="item in resolutionPs" :key="item.value" @click="switchResolutionP(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <img class="close" v-if="!liveBroadcast" src="@/icon/real-video/close.png" @click="close" />
      </div>
    </div>
    <!-- 底部控制栏 -->
    <div v-show="showTool" :id="isCloudRoom === 'cloudRoom' ? 'controllerTemplate' : ''" class="video_controller">
      <img v-if="isVideoPlay" class="video_pause" src="@/icon/real-video/video-pause.png" @click="switchVideoPlay" />
      <img v-else class="video_pause" src="@/icon/real-video/video-play.png" @click="switchVideoPlay" />
      <div class="progress_time">
        <progress value="100" max="100" class="video_progress"></progress>
        <span class="video_time">{{ playedTime }}</span>
      </div>
      <img
        v-if="muted === true"
        class="video_volume"
        :class="{ forbidClick: forbidClick }"
        src="@/icon/real-video/volume-off.png"
        @click="toggleMute"
      />
      <img
        v-else
        class="video_volume"
        :class="{ forbidClick: forbidClick }"
        src="@/icon/real-video/volume-up.png"
        @click="toggleMute"
      />
      <img class="video_plat" v-if="!showMiaPlay" @click="handleMiamuteMic" src="@/icon/real-video/microphone.png" />
      <img class="video_plat" v-if="showMiaPlay" @click="handleMiaunmuteMic" src="@/icon/real-video/microphone-off.png" />
      <img class="full_btn" src="@/icon/real-video/fullscreen.png" @click="switchFullScreen" />
    </div>
  </div>
</template>

<script>
import {
  helmetJoinMeet,
  helmetExitMeet,
  changeResolutionP,
  setHandleHelmetLeave,
  setHandleHelmetOperationResponse,
  handleHelmetOperationResponse,
  muteMic,
  unmuteMic,
  leaveRoomSelf,
  setresolvingPower,
  refleshJoin,
  localMiasoupMuteMic,
  localMdiasoupUnmuteMic
} from '@/common/rtc/mediasoup/mediasoup-util'
import { PrefixInteger, getSession } from '@/api/common'
import { operations } from '@/api/log/operation'
import { setUserHelmetLeave } from '@/common/websocket/index'
import { videoSignal } from '@/util/networkSignal'

import { ACTION, initSwitch, switchAction } from '@/common/websocket/remoteControl'
export default {
  name: 'RealVideo',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
      require: true,
    },
    resolutionP: {
      type: Number,
      default: 12,
    },
    // 是否允许出现上下控制栏
    allowClick: {
      type: Boolean,
      default: false,
    },
    /**
     * 属性说明
     * 左侧树点击：{"deviceName":"HW00200890", "serialNumber":"HW00200890", "userId": "288", "userName": "张三"}
     * 地图点点击：{"deviceName":"HW00200890", "userId": "288", "userName":"张三"}
     */
    currentItem: {
      type: Object,
    },
    deviceName: {
      type: String,
    },
    // 判断是否为直播跳转使用
    liveBroadcast: {
      type: Object,
    },
  },
  data() {
    return {
      // 禁止点击class
      forbidClick: true,
      resolutionPs: [
        { label: this.$t('fluent'), value: 10 },
        { label: this.$t('standardDefinition'), value: 12 },
        { label: this.$t('highDefinition'), value: 14 },
      ],
      playedTime: '00:00:00',
      // 展示工具栏
      showTool: false,
      // 展示的播放状态，不代表视频真的在播放，video.paused可以获取真实的状态
      isVideoPlay: true,
      muted: true,
      isFullScreen: false,
      ACTION,
      currentDefinit: this.$t('standardDefinition'),
      // 是否显示清晰度列表
      definitShow: false,
      /**
       * 用于，点击左侧用户直接关闭视频切换另一个用户，重新等于传值 device
       * 如果传 {serialNumber： null， username：null}，使用前一个数据
       */
      newDevice: [],
      newCurrentItem: [],
      // 用于 记录视频关闭操作，{userId: '',userName: ''}
      userData: [],
      // 执法仪 直播跳转视频 工具栏 不显示
      toolClose: false,
      isCloudRoom: this.$store.getters.rtcType !== 'mediasoup',
      isHasMedia: null,
      reflash: require('@/icon/real-video/reflash-off.png'),
      reflashClass: true,
      // 新旧版样式loading 区分
      loadingGif: true,
      // 区分打开与否视频的关闭操作
      openVideo: false,
      opened: false,
      // 是否显示本地静音图标
      showMiaPlay: true,
    }
  },
  mounted() {
    if (window.location.href.indexOf('newIndex') !== -1) {
      this.loadingGif = true
    } else {
      this.loadingGif = false
    }
  },
  computed: {
    helpVideoStatus() {
      return this.$store.state.helpVideo
    },
    helmetStatus() {
      return this.$store.state.helmetStatusObj[this.device.serialNumber]
    },
    resolvingPower() {
      // console.log('清晰度', this.$store.state.handleresolutionP)
      return this.$store.state.handleresolutionP
    },
    getSign() {
      if (
        this.helmetStatus.WIFI !== '0' &&
        this.helmetStatus.WIFI !== '-2' &&
        this.helmetStatus.WIFI !== '-1' &&
        this.helmetStatus.WIFI !== '-3'
      ) {
        switch (this.helmetStatus.WIFI) {
          case '1':
            return require('@/icon/real-video/wifi1.png')
          case '2':
            return require('@/icon/real-video/wifi2.png')
          case '3':
            return require('@/icon/real-video/wifi3.png')
          case '4':
            return require('@/icon/real-video/wifi4.png')
          default:
            return require('@/icon/real-video/wifi4.png')
        }
      } else if (this.helmetStatus.phoneSign !== '0' && this.helmetStatus.networkSignal) {
        if (this.device && this.device.serialNumber && this.device.serialNumber.indexOf('HWIH07') > -1) {
          return videoSignal('5', this.helmetStatus.networkSignal)
        } else {
          switch (this.helmetStatus.phoneSign) {
            case '2':
              return videoSignal('2', this.helmetStatus.networkSignal)
            case '3':
              return videoSignal('3', this.helmetStatus.networkSignal)
            case '4':
              return videoSignal('4', this.helmetStatus.networkSignal)
            default:
              return require('@/icon/real-video/4g.png')
          }
        }
      }
    },
    getSignTitle() {
      if (this.helmetStatus.WIFI !== '0') {
        return 'wifi'
      } else if (this.helmetStatus.phoneSign !== '0') {
        return 'mobile'
      } else {
        return ''
      }
    },
    isLocalStreamPublish() {
      return this.$store.state.isLocalStreamPublish
    },
  },
  methods: {
    // 点击本地静音
    handleMiamuteMic() {
      localMiasoupMuteMic()
      this.showMiaPlay = true
    },
    // 点击本地取消静音
    handleMiaunmuteMic() {
      localMdiasoupUnmuteMic()
      this.showMiaPlay = false
    },
    // 播放视频:使用mediasoup播放实时视频流
    playVideo() {
      if (this.opened === true) return
      if (this.opened === false) {
        this.opened = true
        setTimeout(() => {
          this.opened = false
        }, 1000)
      }
      setTimeout(() => {
        let userId = null
        let username = null
        this.playedTime = '00:00:00'
        // 一键求助时 取websocket返回的userId username
        if (!this.currentItem.userId) {
          userId = this.$store.state.helpInfo.userId
          username = this.$store.state.helpInfo.username
          if (this.device.serialNumber.indexOf('ZFY') !== -1) {
            // 如果是执法仪，则顺时针旋转视频90度
            this.toolClose = true
          }
        } else {
          if (this.$store.state.helpInfo.statusInfo) {
            userId = this.$store.state.helpInfo.userId
            username = this.$store.state.helpInfo.username
            if (this.device.serialNumber && this.device.serialNumber.indexOf('ZFY') !== -1) {
              // 如果是执法仪，则顺时针旋转视频90度
              this.toolClose = true
            } else {
              this.toolClose = false
            }
          } else {
            userId = this.currentItem.userId
            username = this.currentItem.userName
            this.toolClose = this.allowClick
          }
        }
        // 视频为直播时候
        if (this.liveBroadcast && this.liveBroadcast.IsLive) {
          userId = this.liveBroadcast.currentNode.userId
          username = this.liveBroadcast.currentNode.name
        }
        console.log(this.$store.state.helpInfo, 'this.$store.state.helpInfo.')
        this.openVideo = true
        helmetJoinMeet(this.device.serialNumber, 12, userId, username)
        initSwitch(this.device.serialNumber)

        let param = [
          {
            childOperation: 51,
            event: -1,
            logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
            loginUserName: getSession('username'),
            operation: '实时视频',
            remoteHelmetId: this.device.serialNumber,
            remoteUserId: userId,
            remoteUserName: username,
            // operationIp: getSession('localIp')
          },
        ]
        operations(param)
      }, 1000)
    },
    // 关闭窗口
    close() {
      // 实时视频全屏处理
      if (this.isFullScreen) {
        this.switchFullScreen()
      }

      this.isVideoPlay = true
      setHandleHelmetOperationResponse(() => {})
      setUserHelmetLeave(() => {})
      // 清空全局实时视频组件 数据
      this.$store.commit('changeVideoInfo', {})
      this.$store.commit('changeOpenVideo', false)
      this.$store.commit('setHelpVideo', false)
      if (this.$store.getters.rtcType === 'cloudRoom') {
        // helmetExitMeetCR(this.device.serialNumber)
        // // 退出后清空消息响应处理
        // // setHandleHelmetOperationResponseCR(() => {})
        // setHandleHelmetLeaveCR(() => {})
        // let videoTag = document.getElementById('video' + this.userData.userName)
        // ExitTheRoom(this.userData.userId)
        // clearInterval(pollInterval)
        // this.isHasMedia = videoTag
        // if (this.isHasMedia !== null) {
        //   videoTag.parentNode.removeChild(videoTag)
        //   videoTag.remove()
        // }
      } else {
        helmetExitMeet(this.device.serialNumber)
        setHandleHelmetLeave(() => {})
        if (this.$refs.video) {
          this.isHasMedia = this.$refs.video.srcObject
          this.$refs.video.srcObject = null
        }
      }
      // 视频为直播时候的关闭操作
      this.$emit('handleClose')
      this.currentDefinit = this.$t('standardDefinition')
      if (this.isHasMedia !== null && this.openVideo) {
        // 离开房间
        let userId = null
        let username = null
        if (this.currentItem) {
          userId = this.currentItem.userId
          username = this.currentItem.userName
          this.$store.commit('isPlayTrack', true)
        }
        if (!userId) {
          userId = this.$store.state.helpInfo.userId
          username = this.$store.state.helpInfo.username
        }
        // 视频为直播时候
        if (this.liveBroadcast && this.liveBroadcast.IsLive) {
          userId = this.liveBroadcast.currentNode.userId
          username = this.liveBroadcast.currentNode.name

          this.$emit('update:device', {})
        }
        let param = [
          {
            childOperation: 51,
            event: 0,
            logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
            loginUserName: getSession('username'),
            operation: '实时视频',
            remoteHelmetId: this.device.serialNumber,
            remoteUserId: userId,
            remoteUserName: username,
            // operationIp: getSession('localIp')
          },
        ]
        this.$store.commit('openVedio', false)
        operations(param)
        // 退出后清空消息响应处理
        leaveRoomSelf()
        this.openVideo = false
      }
      if(!this.$store.state.helpInfo) {
        this.$store.commit('changeHelpInfo', {
          serialNumber: null,
          username: null,
          userId: null,
        })
      }
      // 视频为直播时候的关闭操作
      // if(this.liveBroadcast) {
      //   this.$emit('handleClose')
      // }
    },
    // 切换全屏状态
    switchFullScreen() {
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        // 全屏
        if (document.documentElement.webkitRequestFullScreen) {
          this.$refs.box.webkitRequestFullScreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          this.$refs.box.mozRequestFullScreen()
        } else if (document.documentElement.msRequestFullScreen) {
          this.$refs.box.msRequestFullScreen()
        }
      } else {
        // 退出全屏
        if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    // 切换视频播放状态
    switchVideoPlay() {
      this.isVideoPlay = !this.isVideoPlay
      if (this.$store.getters.rtcType === 'cloudRoom') {
        // 云屋切换状态
        // var video = stateData.vedioId
        // if (this.isVideoPlay) {
        //   // 播放中
        //   video.play()
        // } else {
        //   video.pause()
        // }
      } else {
        // console.log(!this.muted, !this.isVideoPlay)
        if (!this.muted && !this.isVideoPlay) {
          // 静音
          muteMic(!this.muted)
          localMiasoupMuteMic()
        } else {
          this.switchMuted()
          localMdiasoupUnmuteMic()
        }
        if (this.isVideoPlay) {
          // 播放中
          this.$refs.video.play()
        } else {
          this.$refs.video.pause()
        }
      }
    },
    toggleMute() {
      // true静音
      this.muted = !this.muted
      this.$store.commit('setHelpVideo', false)
      if (this.isVideoPlay) {
        this.switchMuted()
      }
    },
    // 切换静音状态
    switchMuted() {
      if (this.$store.getters.rtcType === 'cloudRoom') {
        // let stateUserId = stateData.user_id
        // if (this.muted) {
        //   // 判断后台是否有麦克风，若没有，只开通头盔麦克风，否则开通后台和头盔的麦克风
        //   if (CRVideo_GetAudioMicNames().length > 0) {
        //     // 后台有麦克风
        //     // 开启后台麦克风
        //     CRVideo_OpenMic(stateUserId)
        //     CRVideo_OpenMic(this.device.username)
        //   }
        // } else {
        //   // 关闭头盔麦克风
        //   CRVideo_CloseMic(this.device.username)
        //   // 关闭后台麦克风
        //   CRVideo_CloseMic(stateUserId)
        // }
      } else {
        // console.log('this.muted', this.muted)
        if (this.muted) {
          // 静音（暂停生产流）
          muteMic(this.muted)
          let audioArr = document.getElementById('mvcpAudio1')
          // console.log(audioArr.childNodes)
          audioArr.childNodes.forEach(element => {
            element.muted = true
          })
        } else {
          // 解除静音
          unmuteMic(this.muted)
          let audioArr = document.getElementById('mvcpAudio1')
          // console.log(audioArr.childNodes)
          audioArr.childNodes.forEach(element => {
            element.muted = false
          })
        }
      }
    },
    // 视频播放时间更新
    timeupdate() {
      if (this.$refs.video) {
        let timeDisplay = 0
        let time = this.$refs.video.currentTime
        var hour = Math.floor(time / 3600)
        var minute = Math.floor((time % 3600) / 60)
        var second = Math.floor(time % 60)
        this.playedTime = PrefixInteger(hour, 2) + ':' + PrefixInteger(minute, 2) + ':' + PrefixInteger(second, 2)
        // console.log(PrefixIntege/r(second, 1))
        if (this.isVideoPlay) {
          // var videoTime = setInterval(()=>{
          if (timeDisplay > PrefixInteger(second, 1)) {
            this.sendreFlash()
          } else {
            timeDisplay = second
          }
          // console.log('timeDisplay',timeDisplay)
          // },3000)
        } else {
          // clearInterval(videoTime)
        }
      }
    },
    // 遥控器指令
    switchAction(action) {
      let userId = null
      let username = null
      if (!this.currentItem.userId) {
        userId = this.$store.state.helpInfo.userId
        username = this.$store.state.helpInfo.username
      } else {
        userId = this.currentItem.userId
        username = this.currentItem.userName
      }
      // 视频为直播时候
      if (this.liveBroadcast && this.liveBroadcast.IsLive) {
        userId = this.liveBroadcast.currentNode.userId
        username = this.liveBroadcast.currentNode.name
      }

      switchAction(this.device.serialNumber, action, userId, username)
    },
    // 点击显示的清晰度=》显示下拉的清晰度列表
    showList() {
      this.definitShow = true
    },
    // 切换分辨率
    switchResolutionP(resolutionP) {
      this.definitShow = false
      this.currentDefinit = resolutionP.label
      if (this.$store.getters.rtcType === 'cloudRoom') {
        // changeResolutionPCR(this.device.serialNumber, resolutionP.value)
      } else {
        changeResolutionP(this.device.serialNumber, resolutionP.value)
      }
    },
    // 刷新安全帽按钮
    reflashHelmet() {
      console.log('刷新')
      this.sendreFlash()
      this.reflashClass = false
      this.isVideoPlay = true
      this.reflash = require('@/icon/real-video/reflash-on.png')
      setTimeout(() => {
        this.reflash = require('@/icon/real-video/reflash-off.png')
      }, 200)
      // 10秒内刷新一次
      setTimeout(() => {
        this.reflashClass = true
      }, 10000)
    },
    async sendreFlash() {
      await helmetExitMeet(this.device.serialNumber)
      await leaveRoomSelf()
      setTimeout(() => {
        refleshJoin(!this.muted)
      }, 2000)

      // var sendMsg = {
      //   action: 7,
      // }
      // CHAT.chat(10, this.device.serialNumber, sendMsg)
    },

    handleDefinit(val) {
      this.currentDefinit = ''
      if (val === 10) {
        this.currentDefinit = this.$t('fluent')
      } else if (val === 12) {
        this.currentDefinit = this.$t('standardDefinition')
      } else {
        this.currentDefinit = this.$t('highDefinition')
      }
      // console.log(this.currentDefinit)
    },
  },
  watch: {
    'device.serialNumber': {
      immediate: true,
      handler(val) {
        if (val) {
          console.log(val, '打开实时视频')
          // 播放新实时视频时 自定义消息响应处理
          if (this.$store.getters.rtcType === 'cloudRoom') {
            // setHandleHelmetOperationResponse(handleHelmetOperationResponseCR)
            // setHandleHelmetLeaveCR(this.close)
          } else {
            setHandleHelmetOperationResponse(handleHelmetOperationResponse)
            setHandleHelmetLeave(this.close)
          }
          setUserHelmetLeave(this.close)
          setresolvingPower(this.handleDefinit)
          // 默认静音
          if (this.helpVideoStatus) {
            this.muted = false
            this.showMiaPlay = false
          } else {
            this.muted = true
            this.showMiaPlay = true
          }
          this.playVideo()
        } else {
          // 销毁资源
          // this.close()
          // console.log('serialNumber')
        }
      },
    },
    helmetStatus(val) {
      if (val) {
        if (this.currentItem) {
          this.userData = []
          /**
           * 判断赋值的数组与当前点击的数组，用第三方数组 userData 承接并传值与记录数据使用
           */
          if (this.newCurrentItem.userId && this.newCurrentItem.userId !== this.currentItem.userId) {
            this.userData = this.newCurrentItem
          } else {
            this.userData = this.currentItem
          }
          this.newCurrentItem = this.currentItem
        } else {
          this.userData = {
            userId: this.device.userId,
            userName: this.device.username,
          }
        }
        // 判断当前设备号，用于关闭视频窗口，记录历史记录
        this.newDevice = this.device.serialNumber === null ? this.newDevice : this.device
      }
    },
    isLocalStreamPublish(val) {
      if (val) {
        this.forbidClick = false
      } else {
        this.forbidClick = true
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('changeHelpInfo', {
      serialNumber: null,
      username: null,
      userId: null,
    })
    // 销毁资源
    this.close()
    // console.log('beforeDestroy')
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.video-box
  position relative
  height 100%
  pointer-events: auto
  .monitor-wrapper
    object-fit fill
    width 100%
    height 100%
  .vedioLoad
    width 100%
    height 100%
    position: absolute
    visibility: hidden
  #videoloading
    width 100%
    height 100%
    position absolute
    top 0px
    #destroyVideo
      width 17px
      height 17px
      margin-top 4px
      margin-right 4px
      float right
      cursor pointer
  video
    object-fit fill
    width 100%
    height 100%
  .monitor_topbar
    opacity 1
    position absolute
    top 0
    left 0
    background-color rgba(0, 0, 0, 0.5)
    width 100%
    height 32px
    z-index 1000
    color #fff
    letter-spacing 1px
  .monitor_topbar:hover
    opacity 1
  .topbar_left
    float left
    width 22%
    padding 0 10px
    line-height 32px
    .userName
      width calc(100% - 21px)
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .net_type
      width 17px
      height 17px
      padding-top 6px
      padding-left 4px
  .topbar_mid
    position absolute
    left 50%
    top 0px
    transform translate(-50%, 0)
    cursor pointer
    height 32px
    display flex
    justify-content center
    align-content center
    .reflashClass
      pointer-events: auto
    .forbind_reflash
      cursor: default
      pointer-events: none
    img
      height 17px
      margin-top 8px
      padding 0 10px
      float left
      text-align center
      line-height 32px
      border-right 1px solid #888
  .topbar_right
    float right
    padding 0px 10px
    .definit
      position relative
      margin-right 10px
      .resolut-list
        position absolute
        top 32px
        left 50%
        transform translate(-50%, 0)
        min-width: 50px;
        ul
          background-color rgba(0, 0, 0, 0.5)
          color #fff
          text-align center
          li
            width 100%
            line-height 26px; /* no */
    .resolution-video
      float left
      margin-right 5px
      cursor pointer
      color #fff
      line-height 32px
    .close
      width 17px
      height 17px
      margin-top 8px
      cursor pointer
  .topbar-padding
    padding 0
.video_controller
  position absolute
  bottom 0
  left 0
  background-color rgba(0, 0, 0, 0.5)
  width 100%
  height 33px
  line-height 33px
  z-index 1000
  color #fff
  letter-spacing 1px
  .forbidClick
    pointer-events: none;
  .video_pause
    width 23px
    height 23px
    float left
    left 10px
    top 5px
    position absolute
    cursor pointer
  .progress_time
    height 3px
    width 74%
    position absolute
    left 46px
    top 0
  .video_progress
    height 3px
    width calc(100% - 60px); /* no */
    float right
    margin-top 15px
  .video_time
    font-size 12px
    color white
    width 60px; /* no */
    margin-top 0px
    float left
  .video_volume
    cursor pointer
    width 23px
    height 23px
    position absolute
    right 38px
    top 5px
  .video_plat
    cursor: pointer;
    position: absolute;
    right: 70px;
    top: 5px;
    width: 23px;
    height: 23px;
  .full_btn
    width 30px
    height 30px
    position absolute
    right 5px
    top 3px
    cursor pointer
    bottom 26px
</style>
